/**
 * FilterGroup Molecule Component
 * Reusable filter component for various filter types
 */

'use client'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

export interface FilterOption {
	value: string
	label: string
	count?: number
}

interface FilterGroupProps {
	title: string
	options: FilterOption[]
	selectedValues: string[]
	onChange: (values: string[]) => void
	className?: string
}

export function FilterGroup({
	title,
	options,
	selectedValues,
	onChange,
	className,
}: FilterGroupProps) {
	const handleToggle = (value: string) => {
		const newValues = selectedValues.includes(value)
			? selectedValues.filter(v => v !== value)
			: [...selectedValues, value]

		onChange(newValues)
	}

	return (
		<div className={cn('space-y-3', className)}>
			<h3 className='font-semibold text-[#09194D]'>{title}</h3>

			<div className='space-y-2'>
				{options.map(option => (
					<div
						key={option.value}
						className='flex items-center space-x-2'
					>
						<Checkbox
							id={`filter-${option.value}`}
							checked={selectedValues.includes(option.value)}
							onCheckedChange={() => handleToggle(option.value)}
						/>
						<Label
							htmlFor={`filter-${option.value}`}
							className='flex-1 cursor-pointer text-sm font-normal'
						>
							{option.label}
							{option.count !== undefined && (
								<span className='ml-1 text-gray-500'>({option.count})</span>
							)}
						</Label>
					</div>
				))}
			</div>
		</div>
	)
}
